export var MemberPaymentCardWalletActionType;
(function (MemberPaymentCardWalletActionType) {
    MemberPaymentCardWalletActionType["Loading"] = "Loading";
    MemberPaymentCardWalletActionType["Loaded"] = "Loaded";
    MemberPaymentCardWalletActionType["FailedToLoad"] = "FailedToLoad";
    MemberPaymentCardWalletActionType["OpenModal"] = "OpenModal";
    MemberPaymentCardWalletActionType["CloseModal"] = "CloseModal";
    MemberPaymentCardWalletActionType["AsyncCallStarted"] = "AsyncCallStarted";
    MemberPaymentCardWalletActionType["AsyncCallCompleted"] = "AsyncCallCompleted";
})(MemberPaymentCardWalletActionType || (MemberPaymentCardWalletActionType = {}));
